import React from "react";
import { Avatar, Chip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import useStyles from "./UseStyles";


function ButtonActions(props){
    const classes = useStyles();
    const { handleEdit, onShowDelete, disableEdit, disableDelete, showEdit, showDelete } = props;

    return (
        <div>
          {
            showEdit !== false ? (
              <Chip
                size="small"
                color="primary"
                avatar={
                  <Avatar>
                    <EditIcon size="small" style={{ color: "#fff", padding: "2px" }} />
                  </Avatar>
                }
                label="Edit"
                onClick={handleEdit}
                className={classes.chip}
                variant="outlined"
                disabled={disableEdit}
              />
            ) : ""
          }
          
          {
            showDelete !== false ? (
              <Chip
                size="small"
                color="secondary"
                avatar={
                  <Avatar>
                    <DeleteIcon size="small" style={{ color: "#fff", padding: "2px" }} />
                  </Avatar>
                }
                label="Delete"
                onClick={onShowDelete}
                className={classes.chip}
                variant="outlined"
                disabled={disableDelete}
              />
            ) : ""
          }          
        </div>
      );
}

export default ButtonActions;